// 005 FR-028, FR-030, FR-034: one product's server quantity, pending state and change, for the
// selected student; disabled offline and while the school isn't taking orders.
import { useNetworkStatus } from "@/shell/useNetworkStatus";

import { lineKey, quantityIn } from "./cartStore";
import { useCart } from "./useCart";

export function useLines(studentId: string | null, schoolActive: boolean) {
  const { cart, pending, error, actions } = useCart();
  const { online } = useNetworkStatus();
  const disabled = !online || !schoolActive || studentId === null;
  return {
    online,
    disabled,
    error,
    clearError: actions.clearError,
    addFullSet: actions.addFullSet,
    line(productId: string) {
      const key = studentId ? lineKey(studentId, productId) : null;
      return {
        quantity: studentId ? quantityIn(cart, studentId, productId) : 0,
        pending: key !== null && pending.has(key),
        disabled,
        onChange: (next: number) => {
          if (studentId) actions.setQuantity(studentId, productId, next);
        },
      };
    },
    errorFor(productId: string) {
      return studentId && error?.key === lineKey(studentId, productId)
        ? error.error
        : null;
    },
  };
}
